import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import css from "../css/Addcase.module.css";
import { Link } from 'react-router-dom';
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import Swal from "sweetalert2";
import '../Components/Component-css/Common.css';


const Redeem = ({walletUpdate}) => {
  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
  const nodeMode = process.env.NODE_ENV;
  if (nodeMode === "development") {
    var baseUrl = beckendLocalApiUrl;
  } else {
    baseUrl = beckendLiveApiUrl;
  }
  const history = useHistory()
  
  const [amount, setamount] = useState();
  const [userAllData, setUserAllData] = useState()
    const role = async () => {
        const access_token = localStorage.getItem("token")
        const headers = {
          Authorization: `Bearer ${access_token}`
        }
        await axios.get(baseUrl+`me`, { headers })
          .then((res) => {
            //console.log(res.data);
            setUserAllData(res.data)
          })
          .catch(e => {
            if (e.response.status == 401) {
              localStorage.removeItem('token');
              localStorage.removeItem('token');
            }
          })
    
      }
      
  useEffect(() => {
       let access_token = localStorage.getItem('token');
        access_token = localStorage.getItem('token');
        if(!access_token)
        {
            window.location.reload()
            history.push("/login");
        }
        role();
    
  }, [])
  

  const deposit = () => {
    if(amount && amount >= 95 && amount <= 100000)
    {
        
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    
    axios.post(baseUrl+`referral/to/wallet`,
     {amount},
      { headers })
      .then((res) => {
          walletUpdate();
       if (res.data.msg === "Invalid Amount") {
          Swal.fire({
            title: "You don't have sufficient amount",
            icon: "warning",
            confirmButtonText: "OK",
          });
        }
        else {
          Swal.fire({
            title: "success",
            icon: "success",
            confirmButtonText: "OK",
          });
        }
        }).catch((e) => {
       alert(e)
        if (e.response.status == 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('token');
                    window.location.reload()
                    history.push("/login")
                  }
      })
    }
    else
    {
        let msg = "Enter Amount";
      if ((!amount)) {
        msg = "Enter Amount";
      }
      else if (95 <= amount <= 100000) {
        msg = "Amount should be more than 95.";
      }
      Swal.fire({
        title: msg,
        icon: "Error",
        confirmButtonText: "OK",
      });
    }
  }
  
  return (
   <>
         <Header user={userAllData} />
      <div className="leftContainer" style={{minHeight:'100vh',height:'100%'}}>
    <div className="redeem_main_section">
        <div className="games_section_redeem">
            <div className="redeem_title">Redeem your refer balance</div>
            <div className="game_section_headline">TDS (0%) will be deducted after
                annual referral earning of ₹15,000.</div>
        </div>
        <div className="game_section_headline">
        Enter Amount (Min: 100, Max: 10000)
        </div>
        <div>
            <div className="MuiFormControl-root MuiTextField-root redeem_input_form">
                    
                  
                      <input
                        className="redeem_input"
                        type="number"
                        value={amount}
                        placeholder="Enter Amount"
                        onChange={(e) => setamount(parseInt(e.target.value))}
                        
                      >
                      </input>
                <small className="redeem_caption">Minimum withdrawal amount ₹95</small>
                <p className="MuiFormHelperText-root redeem_info" >Money will be added to cash.</p>
            </div>
            <div className="redeem_btn_container">
            <button className="redeem_btn cxy" onClick={()=>deposit()}>Redeem</button>
            </div>
        </div>
    </div>
</div>
     
    </>
  );
};
export default Redeem;
